export const getPageName = state => state.page.name;
